import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6c58d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sorry, the page you're looking for does not exist.", -1))

import PageHeading from "@/components/ui/labels/page-heading.vue";
import { RouteNames } from "@/router/RouteNames";
import { DxButton } from "devextreme-vue/button";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'not-found-page',
  setup(__props) {

const router = useRouter();

const onClick = () => {
  router.push({ name: RouteNames.Home });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeading, {
      title: "Not Found",
      icon: "fas fa-exclamation-triangle"
    }),
    _hoisted_2,
    _createVNode(_unref(DxButton), {
      text: "Go to Home Page",
      onClick: onClick
    })
  ]))
}
}

})